export default __webpack_public_path__ + "static/umiami_logo-9f85039dacff5f5a7a167944ed329f8a.png";